import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {NewsComponent} from './pages/news/news.component';
import {SignUpComponent} from './pages/sign-up/sign-up.component';
import {SignInComponent} from './pages/sign-in/sign-in.component';
import {SellingComponent} from './pages/selling/selling.component';
import {PayoutttAppComponent} from './pages/payouttt-app/payouttt-app.component';
import {PrivacyPolicyComponent} from './pages/privacy-policy/privacy-policy.component';
import {FaqComponent} from './pages/faq/faq.component';
import {ContactComponent} from './pages/contact/contact.component';
import {AboutUsComponent} from './pages/about-us/about-us.component';
import {BidComponent} from './pages/bid/bid.component';
import {BuyNowComponent} from './pages/buy-now/buy-now.component';
import {CartComponent} from './pages/cart/cart.component';
import {CategoriesDetailComponent} from './pages/categories-detail/categories-detail.component';
import {CheckoutComponent} from './pages/checkout/checkout.component';
import {ConfirmationComponent} from './pages/confirmation/confirmation.component';
import {NewsDetailComponent} from './pages/news-detail/news-detail.component';
import {SearchComponent} from './pages/search/search.component';
import {SellNowComponent} from './pages/sell-now/sell-now.component';
import {ThankYouComponent} from './pages/thank-you/thank-you.component';
import {ProductDetailComponent} from './pages/product-detail/product-detail.component';
import {SiteLayoutComponent} from './layout/site-layout/site-layout.component';
import {AuthGuardService} from './services/auth-guard.service';
import {environment} from '../environments/environment';

const routes: Routes = [
  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      {path: '', component: HomeComponent},
      {path: 'news', component: NewsComponent},
      {path: 'app', component: PayoutttAppComponent},
      {path: 'sign-up', component: SignUpComponent},
      {path: 'sign-in', component: SignInComponent},
      {path: 'selling', component: SellingComponent},
      {path: 'faq', component: FaqComponent},
      {path: 'contact', component: ContactComponent},
      {path: 'about-us', component: AboutUsComponent},
      {path: 'privacy-policy', component: PrivacyPolicyComponent},
      {path: 'bid', component: BidComponent},
      {path: 'buy-now', component: BuyNowComponent},
      {path: 'cart', component: CartComponent},
      {path: 'categories-detail', component: CategoriesDetailComponent},
      {path: 'checkout', component: CheckoutComponent},
      {path: 'confirmation', component: ConfirmationComponent},
      {path: 'news-detail', component: NewsDetailComponent},
      {path: 'product-detail', component: ProductDetailComponent},
      {path: 'search', component: SearchComponent},
      {path: 'sell-now', component: SellNowComponent},
      {path: 'thank-you', component: ThankYouComponent}
    ]
  },
  {
    path: 'account',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./account-module/account-module.module').then(m => m.AccountModuleModule)
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
